import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'spa',
    loadChildren: () => import('./spa/spa.module').then((m) => m.SpaModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'official',
    loadChildren: () =>
      import('./official/official.module').then((m) => m.OfficialModule),
  },
  {
    path: 'currency',
    loadChildren: () =>
      import('./currency/currency.module').then((m) => m.CurrencyModule),
  },
  {
    path: 'bank',
    loadChildren: () => import('./bank/bank.module').then((m) => m.BankModule),
  },
  {
    path: 'rate',
    loadChildren: () => import('./rate/rate.module').then((m) => m.RateModule),
  },
  {
    path: 'mail',
    loadChildren: () => import('./mail/mail.module').then((m) => m.MailModule),
  },
  {
    path: 'install',
    loadChildren: () =>
      import('./install/install.module').then((m) => m.InstallModule),
  },
  {
    path: 'report',
    loadChildren: () =>
      import('./report/report.module').then((m) => m.ReportModule),
  },
  {
    path: 'department',
    loadChildren: () =>
      import('./department/department.module').then((m) => m.DepartmentModule),
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'role',
    loadChildren: () => import('./role/role.module').then((m) => m.RoleModule),
  },
  {
    path: 'permission',
    loadChildren: () =>
      import('./permission/permission.module').then((m) => m.PermissionModule),
  },
  {
    path: 'invoice',
    loadChildren: () =>
      import('./invoice/invoice.module').then((m) => m.InvoiceModule),
  },
  {
    path: 'admin/applications',
    loadChildren: () =>
      import('./adminapplication/adminapplication.module').then(
        (m) => m.AdminapplicationModule,
      ),
  },{
    path: 'admin/students',
    loadChildren: () =>
      import('./adminstudents/adminstudents.module').then(
        (m) => m.AdminstudentsModule,
      ),
  },{
    path: 'admin/instructors',
    loadChildren: () =>
      import('./admininstructor/admininstructor.module').then(
        (m) => m.AdmininstructorModule,
      ),
  },{
    path: 'admin/clients',
    loadChildren: () =>
      import('./adminclient/adminclient.module').then(
        (m) => m.AdminclientModule,
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'expense',
    loadChildren: () =>
      import('./expense/expense.module').then((m) => m.ExpenseModule),
  },
  {
    path: 'systemsettings',
    loadChildren: () =>
      import('./systemsettings/systemsettings.module').then(
        (m) => m.SystemsettingsModule,
      ),
  },
  {
    path: 'systemlog',
    loadChildren: () =>
      import('./systemlog/systemlog.module').then((m) => m.SystemlogModule),
  },
  {
    path: 'supportcenter',
    loadChildren: () =>
      import('./supportcenter/supportcenter.module').then(
        (m) => m.SupportcenterModule,
      ),
  },
  {
    path: 'apptraffic',
    loadChildren: () =>
      import('./apptraffic/apptraffic.module').then((m) => m.ApptrafficModule),
  },
  {
    path: 'openjob',
    loadChildren: () =>
      import('./openjob/openjob.module').then((m) => m.OpenjobModule),
  },
  // {
  //   path: 'welcome',
  //   loadChildren: () =>
  //     import('./welcome/welcome.module').then((m) => m.WelcomeModule),
  // },
  {
    path: 'student',
    loadChildren: () =>
      import('./student/student.module').then((m) => m.StudentModule),
  },
  {
    path: 'instructor',
    loadChildren: () =>
      import('./instructor/instructor.module').then((m) => m.InstructorModule),
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./client/client.module').then((m) => m.ClientModule),
  },{
    path: 'adminstaff',
    loadChildren: () =>
      import('./adminstaff/adminstaff.module').then((m) => m.AdminstaffModule),
  },
  {
    path: 'aboutus',
    loadChildren: () =>
      import('./aboutus/aboutus.module').then((m) => m.AboutusModule),
  },
  {
    path: 'ourmission',
    loadChildren: () =>
      import('./ourmission/ourmission.module').then((m) => m.OurmissionModule),
  },
  {
    path: 'whychooseus',
    loadChildren: () =>
      import('./whychooseus/whychooseus.module').then(
        (m) => m.WhychooseusModule,
      ),
  },
  {
    path: 'partners',
    loadChildren: () =>
      import('./partners/partners.module').then((m) => m.PartnersModule),
  },
  {
    path: 'projectsandportfolio',
    loadChildren: () =>
      import('./projectsandportfolio/projectsandportfolio.module').then(
        (m) => m.ProjectsandportfolioModule,
      ),
  },
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./contact/contact.module').then((m) => m.ContactModule),
  },
  {
    path: 'customsoftware',
    loadChildren: () =>
      import('./customsoftware/customsoftware.module').then(
        (m) => m.CustomsoftwareModule,
      ),
  },
  {
    path: 'networking',
    loadChildren: () =>
      import('./networking/networking.module').then((m) => m.NetworkingModule),
  },
  {
    path: 'outsource',
    loadChildren: () =>
      import('./outsource/outsource.module').then((m) => m.OutsourceModule),
  },
  {
    path: 'itconsulting',
    loadChildren: () =>
      import('./itconsulting/itconsulting.module').then(
        (m) => m.ItconsultingModule,
      ),
  },
  {
    path: 'webdevlopment',
    loadChildren: () =>
      import('./webdevlopment/webdevlopment.module').then(
        (m) => m.WebdevlopmentModule,
      ),
  },
  {
    path: 'mobiledev',
    loadChildren: () =>
      import('./mobiledev/mobiledev.module').then((m) => m.MobiledevModule),
  },
  {
    path: 'dataanalysis',
    loadChildren: () =>
      import('./dataanalysis/dataanalysis.module').then(
        (m) => m.DataanalysisModule,
      ),
  },
  {
    path: 'cybersecurity',
    loadChildren: () =>
      import('./cybersecurity/cybersecurity.module').then(
        (m) => m.CybersecurityModule,
      ),
  },
  {
    path: 'aiandautomation',
    loadChildren: () =>
      import('./aiandautomation/aiandautomation.module').then(
        (m) => m.AiandautomationModule,
      ),
  },
  {
    path: 'cloudsecurity',
    loadChildren: () =>
      import('./cloudsecurity/cloudsecurity.module').then(
        (m) => m.CloudsecurityModule,
      ),
  },
  {
    path: 'digitalliteracy',
    loadChildren: () =>
      import('./digitalliteracy/digitalliteracy.module').then(
        (m) => m.DigitalliteracyModule,
      ),
  },
  {
    path: 'bootcamps',
    loadChildren: () =>
      import('./bootcamps/bootcamps.module').then((m) => m.BootcampsModule),
  },
  {
    path: 'availablepositions',
    loadChildren: () =>
      import('./availablepositions/availablepositions.module').then(
        (m) => m.AvailablepositionsModule,
      ),
  },
  {
    path: 'internships',
    loadChildren: () =>
      import('./internships/internships.module').then(
        (m) => m.InternshipsModule,
      ),
  },
  {
    path: 'freelance',
    loadChildren: () =>
      import('./freelance/freelance.module').then((m) => m.FreelanceModule),
  },
  {
    path: 'requestaquote',
    loadChildren: () =>
      import('./requestaquote/requestaquote.module').then(
        (m) => m.RequestaquoteModule,
      ),
  },
  {
    path: 'startaproject',
    loadChildren: () =>
      import('./startaproject/startaproject.module').then(
        (m) => m.StartaprojectModule,
      ),
  },
  {
    path: 'generalenquiry',
    loadChildren: () =>
      import('./generalenquiry/generalenquiry.module').then(
        (m) => m.GeneralenquiryModule,
      ),
  },
  {
    path: 'myprofile',
    loadChildren: () =>
      import('./myprofile/myprofile.module').then((m) => m.MyprofileModule),
  },
  {
    path: 'studentdashboard',
    loadChildren: () =>
      import('./studentdashboard/studentdashboard.module').then(
        (m) => m.StudentdashboardModule,
      ),
  },
  {
    path: 'studentprofile',
    loadChildren: () =>
      import('./studentprofile/studentprofile.module').then(
        (m) => m.StudentprofileModule,
      ),
  },
  {
    path: 'mycourses',
    loadChildren: () =>
      import('./mycourses/mycourses.module').then((m) => m.MycoursesModule),
  },
  {
    path: 'learningmaterials',
    loadChildren: () =>
      import('./learningmaterials/learningmaterials.module').then(
        (m) => m.LearningmaterialsModule,
      ),
  },
  {
    path: 'assignments',
    loadChildren: () =>
      import('./assignments/assignments.module').then(
        (m) => m.AssignmentsModule,
      ),
  },
  {
    path: 'attendance',
    loadChildren: () =>
      import('./attendance/attendance.module').then((m) => m.AttendanceModule),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'forum',
    loadChildren: () =>
      import('./forum/forum.module').then((m) => m.ForumModule),
  },
  {
    path: 'instructordashboard',
    loadChildren: () =>
      import('./instructordashboard/instructordashboard.module').then(
        (m) => m.InstructordashboardModule,
      ),
  },
  {
    path: 'instructorprofile',
    loadChildren: () =>
      import('./instructorprofile/instructorprofile.module').then(
        (m) => m.InstructorprofileModule,
      ),
  },
  {
    path: 'instructorclasses',
    loadChildren: () =>
      import('./instructorclasses/instructorclasses.module').then(
        (m) => m.InstructorclassesModule,
      ),
  },
  {
    path: 'instructorstudents',
    loadChildren: () =>
      import('./instructorstudents/instructorstudents.module').then(
        (m) => m.InstructorstudentsModule,
      ),
  },
  {
    path: 'instructorattendance',
    loadChildren: () =>
      import('./instructorattendance/instructorattendance.module').then(
        (m) => m.InstructorattendanceModule,
      ),
  },
  {
    path: 'instructorassignments',
    loadChildren: () =>
      import('./instructorassignments/instructorassignments.module').then(
        (m) => m.InstructorassignmentsModule,
      ),
  },
  {
    path: 'instructorlearningmaterials',
    loadChildren: () =>
      import('./instructorlearningmaterials/instructorlearningmaterials.module').then(
        (m) => m.InstructorlearningmaterialsModule,
      ),
  },
   {
    path: 'instructorreports',
    loadChildren: () =>
      import('./instructorreports/instructorreports.module').then(
        (m) => m.InstructorreportsModule,
      ),
  },{
    path: 'instructorprojects',
    loadChildren: () =>
      import('./instructorprojects/instructorprojects.module').then(
        (m) => m.InstructorprojectsModule,
      ),
  },{
    path: 'clientprofile',
    loadChildren: () =>
      import('./clientprofile/clientprofile.module').then(
        (m) => m.ClientprofileModule,
      ),
  },{
    path: 'clientdashboard',
    loadChildren: () =>
      import('./clientdashboard/clientdashboard.module').then(
        (m) => m.ClientdashboardModule,
      ),
  },{
    path: 'clientprojectnegotiation',
    loadChildren: () =>
      import('./clientprojectnegotiation/clientprojectnegotiation.module').then(
        (m) => m.ClientprojectnegotiationModule,
      ),
  },{
    path: 'clientinvoices',
    loadChildren: () =>
      import('./clientinvoices/clientinvoices.module').then(
        (m) => m.ClientinvoicesModule,
      ),
  },{
    path: 'clientprojectdocuments',
    loadChildren: () =>
      import('./clientprojectdocuments/clientprojectdocuments.module').then(
        (m) => m.ClientprojectdocumentsModule,
      ),
  },{
    path: 'clientcommunication',
    loadChildren: () =>
      import('./clientcommunication/clientcommunication.module').then(
        (m) => m.ClientcommunicationModule,
      ),
  },{
    path: 'clientprojectrequest',
    loadChildren: () =>
      import('./clientprojectrequest/clientprojectrequest.module').then(
        (m) => m.ClientprojectrequestModule,
      ),
  },{
    path: 'clientprojecttracking',
    loadChildren: () =>
      import('./clientprojecttracking/clientprojecttracking.module').then(
        (m) => m.ClientprojecttrackingModule,
      ),
  },{
    path: 'staffprofile',
    loadChildren: () =>
      import('./staffprofile/staffprofile.module').then(
        (m) => m.StaffprofileModule,
      ),
  },{
    path: 'clientsupport',
    loadChildren: () =>
      import('./clientsupport/clientsupport.module').then(
        (m) => m.ClientsupportModule,
      ),
  },{
    path: 'staffdashboard',
    loadChildren: () =>
      import('./staffdashboard/staffdashboard.module').then(
        (m) => m.StaffdashboardModule,
      ),
  },{
    path: 'staffattendance',
    loadChildren: () =>
      import('./staffattendance/staffattendance.module').then(
        (m) => m.StaffattendanceModule,
      ),
  },{
    path: 'admin/hosting',
    loadChildren: () =>
      import('./adminhosting/adminhosting.module').then(
        (m) => m.AdminhostingModule,
      ),
  },{
    path: 'admin/documents',
    loadChildren: () =>
      import('./admindocuments/admindocuments.module').then(
        (m) => m.AdmindocumentsModule,
      ),
  },{
    path: 'admin/receipts',
    loadChildren: () =>
      import('./adminreceipts/adminreceipts.module').then(
        (m) => m.AdminreceiptsModule,
      ),
  },{
    path: 'admin/jobs',
    loadChildren: () =>
      import('./adminjobs/adminjobs.module').then(
        (m) => m.AdminjobsModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }